import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RouteUtilsService {
  getCurrentUrlQueryParams() {
    let params: any = {};
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }
}
